import brandit_rails from '../../../../api/brandit_rails'
import { setClientsStatusAction, setClientsErrorsAction, setClientOptionsAction } from './clients.actions'

/**
 * Fetch lightweight client options for dropdowns
 * @param {Object} options - Query parameters
 * @param {string} [options.search] - Search clients by name
 */
export const fetchClientOptions =
  (options = {}) =>
  async dispatch => {
    try {
      dispatch(setClientsStatusAction('loading'))

      const { data } = await brandit_rails.request({
        url: '/client_options',
        method: 'GET',
        params: options
      })

      dispatch(setClientOptionsAction(data))
      dispatch(setClientsStatusAction('succeeded'))
      return data
    } catch (err) {
      dispatch(setClientsErrorsAction(err.response?.data || err.message))
      dispatch(setClientsStatusAction('failed'))
      throw err
    }
  }
